<app-step-pre-login
  *ngIf="loginStep === LoginStepEnum.PRE_LOGIN"
  [clientePreLogin]="cliente"
  [loading]="loading"
  (continuar)="salvarDadosPreLogin($event)"
></app-step-pre-login>

<app-step-senha
  *ngIf="loginStep === LoginStepEnum.SENHA"
  [nomeCliente]="nomeCliente"
  [loading]="loginLoading"
  [networkError]="networkError"
  (continuar)="handleEntrar($event)"
  (forgotPassword)="handleForgotPassword()"
></app-step-senha>

<app-step-cliente-sem-carne
  *ngIf="loginStep === LoginStepEnum.RECUSADO"
  (voltar)="handleVoltarAoInicio()"
  (logAcaoCliente)="handleEnviarAcaoCliente($event)"
>
</app-step-cliente-sem-carne>

<app-step-cliente-sem-cadastro
  *ngIf="loginStep === LoginStepEnum.CADASTRO"
></app-step-cliente-sem-cadastro>